import { WithAdditionalMarketoFormOverrideProps } from 'marketing-site/src/components/context/MarketoFormOverridePropsContext'
import {
  IOnMarketoFormSubmit,
  IProps as IMarketoFormV2Props,
  SIGNUP_INTENT,
} from 'marketing-site/src/library/components/MarketoFormV2'
import getSignupIntentRedirectPath from 'marketing-site/src/library/utils/getSignupIntentRedirectPath'
import React from 'react'
import { IPageBehaviorComponentProps } from './PageBehaviors'
import { AnalyticsEvent } from 'marketing-site/src/library/utils/analytics/analyticsEvent'
import useLocaleCode from 'marketing-site/src/library/hooks/useLocaleCode'

export default function InboundPage({ children }: IPageBehaviorComponentProps) {
  const localeCode = useLocaleCode()
  const onMarketoFormSubmit: IOnMarketoFormSubmit = (response, _, emailSubmissionResult) => {
    if (response.success) {
      const redirectUrl = getSignupIntentRedirectPath({
        emailSubmissionResult,
        inboundExperimentEnabled: true,
        localeCode,
      })

      const event = new AnalyticsEvent({
        action: 'clicked',
        object: 'cta',
        place: 'inbound_page_hero',
        context: 'inbound_page',
      })
      event.send()

      window.location.assign(redirectUrl)
    }
  }

  const marketoOverrideProps: Partial<IMarketoFormV2Props> = {
    onSubmit: onMarketoFormSubmit,
    hiddenFieldIds: ['FirstName'],
    emailSubmissionSource: SIGNUP_INTENT,
  }

  return (
    <WithAdditionalMarketoFormOverrideProps overrideProps={marketoOverrideProps}>
      {children}
    </WithAdditionalMarketoFormOverrideProps>
  )
}
